module.exports = __webpack_public_path__ + "assets/img/scenic_12.b83f4481.svg";